const suppliers = {
  suppliers: "Proveedores",
  supplier: "Proveedor",
  supplierName: "Nombre del proveedor",
  supplierEmail: "Correo electrónico del proveedor",
  supplierRegistrationNumber: "Número de registro del proveedor",
  supplierAccountInfo: "Información de la cuenta del proveedor",
  supplierAccountHolderName: "Nombre del titular de la cuenta del proveedor",
  supplierIBAN: "IBAN del proveedor",
  supplierURL: "URL del proveedor",
  onboarding_status: "Estado de incorporación",
  tax_id: `ID de impuestos`,
  power_of_attorney: `Poder legal`,
  acceptance_of_terms_and_conditions: `Aceptación de Términos y Condiciones`,
  legal_representative_info: `Información del representante legal`,
  certificates: `Certificados`,
  bank_account_ownership: `Titularidad de la cuenta bancaria`,
  compliance_with_social_security: `Cumplimiento de la seguridad social`,
  compliance_with_tax_administration: `Cumplimiento con la Administración Tributaria`,
  last_month_payment_installment_of_civil_liability_insurance_policy: `Cuota de pago del último mes de la póliza de seguro de responsabilidad civil`,
  goods_and_services: `Bienes y servicios`,
  other_conditions: `Otras condiciones`,
  view_contract: `Ver contrato`,
  contract_removed_successfully: "Contrato eliminado con éxito",
  delete_contract: `Eliminar contrato`,
  delete_contract_warning: `El contrato eliminado no se puede recuperar`,
  "One or more validations issue,Supplier must have a unique email address.":
    "El proveedor debe tener una dirección de correo electrónico única",
  "No Supplier Contract found.": "No se encontró ningún contrato de proveedor",
  supplier_contract_removed_successfully: `Contrato eliminado exitosamente`,
  currency: `Moneda`,
  view_supplier: `Ver proveedor`,
  erp_code: `Código ERP`,
  invite_status: `Estado de invitación`,
  invite_sent: `Enviada`,
  invite_not_sent: `No enviada`,
  portal_status: `Estado del portal`,
  portal_status_not_invited: `No invitado`,
  portal_status_pending_onboarding: `Incorporación pendiente`,
  portal_status_finished_onboarding: `Incorporación finalizada`,
  portal_status_onboarded: `Incorporado`,
  approval_needed: `Aprobación requerida`,
  approved: `Aprobado`,
  rejected: `Rechazado`,
  legal_document_expires_soon: `El documento legal caduca pronto`,
  legal_document_expired: `Documento legal caducado`,
  send_invite: `Enviar invitación`,
  send_invite_confirmation: `¿Estás seguro de que deseas enviar una invitación a {{count}} proveedor(es)?`,
  send_invite_subtitle: `Selecciona los proveedores pendientes para enviarles una invitación de incorporación`,
  invite_sent_successfully: `Invitación enviada correctamente`,
  invites_sent_successfully: `Invitaciones enviadas correctamente`,
  invite_failed: `Error al enviar la invitación`,
  download_csv: `Descargar CSV`,
  export_csv_failed: `Error al exportar el CSV`,
  no_pending_suppliers: `Todos los proveedores han completado la incorporación`,
  loading_suppliers: `Cargando proveedores...`,
  select_all: `Seleccionar todo`,
  selected: `seleccionados`,
  sending: `Enviando...`,
  companies: `Empresas del cliente`,
  select_all_companies: `Seleccionar todo`,
  add_supplier_information: `Añadir información del proveedor`,
  edit_supplier_information: `Editar información del proveedor`,
  view_supplier_information: `Ver información del proveedor`,
  fill_in_the_vendor_details: `Completa los datos del proveedor`,
  update_the_vendor_details: `Actualiza los datos del proveedor`,
  view_vendor_details: `Ver los datos del proveedor`,
  invite_your_supplier_to_supplier_portal: `Invita a tu proveedor al portal de proveedores`,
  basic_information: `Información básica`,
  bank_information: `Información bancaria`,
  address_information: `Información de dirección`,
  locality: `Localidad`,
  region: `Región`,
  mandatory: `Obligatorio`,
  mandatory_for_supplier: `Obligatorio`,
  delete_document: `Eliminar documento`,
  this_action_cannot_be_undone: `Esta acción no se puede deshacer`,
  vendor_company_name: `Nombre de la empresa del proveedor`,
  vendor_company_id: `ID de la empresa del proveedor`,
  vendor_email: `Correo electrónico del proveedor`,
  enter_vendor_company_name: `Introduce el nombre de la empresa del proveedor`,
  enter_vendor_company_id: `Introduce el ID de la empresa del proveedor`,
  enter_company_id: `Introduce el ID del proveedor`,
  enter_email: `Introduce el correo electrónico`,
  select_a_currency: `Selecciona una moneda`,
  logo_url: `URL del logo`,
  enter_logo_url: `Introduce la URL del logo`,
  customer_companies: `Empresas del cliente`,
  select_customer_companies: `Selecciona las empresas del cliente`,
  enter_account_holder_name: `Introduce el nombre del titular de la cuenta`,
  enter_iban: `Introduce el IBAN`,
  swift_bic_code: `Código Swift / BIC`,
  enter_swift_bic_code: `Introduce el código Swift / BIC`,
  enter_address: `Introduce la dirección`,
  enter_street: `Introduce la calle`,
  enter_street_number: `Introduce el número de la calle`,
  enter_locality: `Introduce la localidad`,
  enter_region: `Introduce la región`,
  enter_zip_code: `Introduce el código postal`,
  enter_fax_number: `Introduce el número de fax`,
  enter_country: `Introduce el país`,
  enter_contact_number: `Introduce el número de contacto`,
  onboarding_template: `Plantilla de incorporación`,
  onboarding_template_description: `Una plantilla de incorporación especifica los grupos de documentos que el proveedor invitado debe enviar`,
  select_an_onboarding_template: `Selecciona una plantilla de incorporación`,
  no_template_selected_hint: `sin plantilla seleccionada`,
  approver_name: `Nombre del aprobador`,
  select_approver: `Selecciona un aprobador`,
  approver_is_required: `El aprobador es obligatorio`,
  assignment_reason: `Motivo del aprobador`,
  enter_assignment_reason: `Introduce el motivo del aprobador`,
  assignment_reason_is_required: `El motivo del aprobador es obligatorio`,
  supported_documents: `Documentos de soporte`,
  add_supported_document: `Añadir documento de soporte`,
  expires_on: `Caduca el`,
  document_expired_on: `Documento caducado el`,
  document_not_configured_for_group: `Este documento no está configurado para el grupo seleccionado`,
  upload_document: `Subir documento`,
  upload_x_document: `Subir documento de {{name}}`,
  update_supplier_before_uploading: `Actualice el proveedor primero y luego suba este documento`,
  other_tab: `Otros`,
  po_tags_and_patterns: `Etiquetas y patrones de OC`,
  po_tags_and_patterns_hint: `Añade etiquetas o patrones para identificar órdenes de compra`,
  tags_and_patterns_placeholder: `Escribe una etiqueta o patrón y pulsa Intro`,
  service_tags_and_patterns: `Etiquetas y patrones de servicio`,
  service_tags_and_patterns_hint: `Añade etiquetas o patrones para identificar servicios`,
  remove_group_documents_to_change_template: `Elimine primero los documentos adjuntos para cambiar la plantilla`,
  onboarding_template_locked_after_completion: `La plantilla de incorporación no se puede cambiar una vez completada la incorporación del proveedor`,
  upload_and_manage_document: `Sube y gestiona el documento`,
  document_name_is_required: `El nombre del documento es obligatorio`,
  set_document_expiry: `Establecer caducidad del documento`,
  expiry_date: `Fecha de caducidad`,
  expiry_date_required: `La fecha de caducidad es obligatoria`,
  upload_new: `Subir nuevo`,
  save_document: `Guardar documento`,
  document_updated_successfully: `Documento guardado correctamente`,
  reopen_supplier_to_add_documents: `Proveedor creado. Vuelve a abrirlo para añadir los documentos.`,
  supplier_created_some_documents_failed: `Proveedor creado, pero {{count}} documento(s) no se pudieron subir`,
  supplier_created_and_invited: `Proveedor creado e invitación enviada correctamente`,
  supplier_created_invite_failed: `Proveedor creado, pero no se pudo enviar la invitación`,
  add_and_send_invite: `Agregar y enviar invitación`,
  failed_to_load_onboarding_templates: `No se pudieron cargar las plantillas de incorporación`,
  failed_to_load_template_groups: `No se pudieron cargar los grupos de documentos de la plantilla`,
  no_permissions_to_view_template: `Sin permisos para ver la plantilla`,
  png_jpeg_pdf_files_accepted_only: `Solo se aceptan archivos PNG, JPEG, PDF`,
  error_fetching_documents: `Ocurrió un error al obtener el proveedor`,
  sections: {
    overview: "Resumen",
    banking: "Datos bancarios",
    documents: "Documentos",
    terms: "Términos",
    vendor_classification: "Clasificación del proveedor",
    service_documents: "Servicio y documentos",
    certificates_tax_files: "Certificados y archivos fiscales",
    accounting_contact: "Contacto de contabilidad",
    primary_bank_account: "Cuenta bancaria principal",
    additional_bank_account: "Cuenta bancaria adicional",
    address_info: "Información de dirección",
  },
  payment_term: `Condición de pago`,
  payment_method: `Método de pago`,
  select_payment_term: `Selecciona una condición de pago`,
  select_payment_method: `Selecciona un método de pago`,
};

export default suppliers;
